import React, { createContext, useContext, useRef } from 'react';
// @ts-ignore
import Cropper from 'react-cropper';


interface CropperContextType {
  cropperRefs: Cropper[]; // Tableau d'instances de Cropper
  addCropperRef: (ref: Cropper) => void;
  removeCropperRef: (ref: Cropper) => void;
}

const CropperContext = createContext<CropperContextType | null>(null);

export const ImageCropperProvider = ({ children }) => {
  const cropperRefs = useRef<Cropper[]>([]);

  const addCropperRef = (ref) => {
    cropperRefs.current.push(ref);
  };

  const removeCropperRef = (ref) => {
    cropperRefs.current = cropperRefs.current.filter((currentRef) => currentRef !== ref);
  };


  return (
    <CropperContext.Provider value={{ cropperRefs: cropperRefs.current, addCropperRef, removeCropperRef }}>
      {children}
    </CropperContext.Provider>
  );
};

export const useCropper = () => {
  return useContext(CropperContext);
};
